import util from 'util';
import { CONSTANT } from '@const';
import { AuthorisationFilter, AuthorisationSummary, AuthType, Page, PageFilter } from '@types';

import { ApiError, ApiParams, ApiService } from '../api/ApiService';

export class AuthorisationService extends ApiService {
	static readonly itemsPerPage = 20;

	static async getAuthorisations(
		clientId: string,
		pageFilter?: PageFilter,
		authorisationFilter?: AuthorisationFilter,
	): Promise<Page<AuthorisationSummary>> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(`${CONSTANT.AUTHORISATIONS_API_URL}`, clientId),
			queryParams: { ...pageFilter, ...authorisationFilter },
		};
		return await this.executeApiRequest(params);
	}

	static async getAuthorisation(clientId: string, authorisationId: string): Promise<AuthType> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(`${CONSTANT.AUTHORISATIONS_DETAILS_API_URL}`, clientId, authorisationId),
		};
		return await this.executeApiRequest(params);
	}

	static async fetchDetails(
		clientId: string,
		authorisations: AuthorisationSummary[],
	): Promise<AuthType[]> {
		const requests = authorisations.map(liteAuthorisation => {
			return this.getAuthorisation(clientId, liteAuthorisation.id);
		});

		const authorisationsWithDetails = await Promise.allSettled(requests).then(results => {
			const responsesData = (
				results.filter(
					result => result.status === 'fulfilled',
				) as PromiseFulfilledResult<AuthType>[]
			).map(result => result.value);

			const responsesErrors = (
				results.filter(result => result.status === 'rejected') as PromiseRejectedResult[]
			).map(result => result.reason);

			if (responsesErrors.length) {
				throw responsesErrors[0] as ApiError;
			}

			return responsesData;
		});

		return authorisationsWithDetails;
	}
}
